import * as Yup from 'yup';

export const model = {
  email: {
    label: '',
    type: 'text',
    name: 'email',
    withBorder: false,
    placeholder: 'Email address ...',
  },
  username: {
    label: '',
    type: 'text',
    name: 'username',
    withBorder: false,
    placeholder: 'Username',
  },
  userPhoto: {
    name: 'userPhoto',
    placeholder: 'Update avatar...',
  },
  googleLink: {
    label: '',
    type: 'text',
    name: 'googleLink',
    withBorder: false,
    placeholder: 'Link Google',
  },
};

export const validationSchema = () => Yup.object().shape({});

export const initialValues = (data: any) => {
  return {
    [model.email.name]: data?.email ?? '',
    [model.username.name]: data?.username ?? '',
  };
};
